import type { Receiver } from "@ceeferenderer/fe-renderer-sdk";
import { process } from "./process";

export const receiver: Receiver = {
  receive: (_topic, data) => {
    process(data);
  },
};
